export const EntityTypeEnum = {
  JobTask: 1,
  Job: 2,
  Vehicle: 3,
  VehicleChecklist: 4,
  IncidentReport: 5,
  ToolboxTalks: 6,
  LeadClientNote: 7,
  JobClientNote: 8,
  SelectionOption: 9,
  Selection: 9
};
